import { Bullhorn, Calendar, Dashboard, Folder, Growth, Music, Rocket, UserMultiple, UserProfile } from '@carbon/icons-react';

import type { CarbonIconType } from '@carbon/icons-react';

import { IconeDaNyta } from '../marcas/MarcaDaNyta';
import { IconeDoControleDeShows } from './iconesDosModulos';
import type { ModuloDaNavegacao } from './NavegacaoDoPerfil';
import { modulosDoMenu } from '@maestra/core/telas/casca/modulos';

// Os módulos do perfil, na ordem do SideNav. A lista (chaves, nomes, grupos e ordem) mora no núcleo
// desde 31/10/2026 (`@maestra/core/telas/casca/modulos`), para o app nativo ter o mesmo menu; aqui a
// web só põe os ícones. Módulo novo entra lá, e o ícone dele aqui.
const ICONES: Record<string, CarbonIconType> = {
  '': Dashboard,
  'perfil-publico': UserProfile,
  desenvolvimento: Growth,
  // O ingresso (o ícone oficial do grupo, em `iconesDosModulos`).
  'controle-de-shows': IconeDoControleDeShows,
  catalog: Music,
  lancamentos: Rocket,
  marketing: Bullhorn,
  agenda: Calendar,
  team: UserMultiple,
  arquivos: Folder,
  nyta: IconeDaNyta as unknown as CarbonIconType,
};

/** O SideNav de quem está logado: o admin vê também as páginas que só ele vê (`modulosDoMenu`). */
export const modulosDoPerfil = (admin: boolean): ModuloDaNavegacao[] => modulosDoMenu(admin).map((m) => ({
  chave: m.chave,
  rotulo: m.rotulo,
  icone: ICONES[m.chave],
  ...(m.filhos ? { filhos: m.filhos.map((f) => ({ chave: f.chave, rotulo: f.rotulo })) } : {}),
}));

export const MODULOS_DO_PERFIL: ModuloDaNavegacao[] = modulosDoPerfil(false);
